import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  BoxStatusItem: {
    display: 'flex',
    padding: '2px 8px',
    alignItems: 'flex-start',
    borderRadius: '16px',
    width: 'max-content',
  },
  TableCell: {
    borderBottom: '1px solid #e0e0e0',
    borderRight: '1px solid #e0e0e0',
    padding: '8px',
  },
}));

export { useStyles };
